// @flow
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { hideFlashBanner } from 'actions/application';

import CloseIcon from 'assets/icons/close.svg';

import { BORDER_RADIUS_F1 } from 'styles/border-radius';
import { SPACING_SMALL, SPACING_MEDIUM, SPACING_LARGE } from 'styles/spacing';
import { CLARK_SECONDARY, TRANSPARENT, OPACITY_25 } from 'styles/colors';
import { TYPE_SCALE_F5, TYPE_SCALE_F6 } from 'styles/type-scale';
import { FONT_WEIGHT_100, FONT_WEIGHT_700 } from 'styles/font-weight';
import { LINE_HEIGHT_TITLE, LINE_HEIGHT_COPY } from 'styles/line-height';

import FLASH_BANNERS from './data';

const mapStateToProps = ({ application: { flash } }) => ({
  flash,
});

const mapDispatchToProps = { dispatchHideFlashBanner: hideFlashBanner };

const enhancer = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);

const bannerData = (type, status) => {
  if (FLASH_BANNERS[type]) {
    return FLASH_BANNERS[type]();
  }
  if (FLASH_BANNERS[status]) {
    return FLASH_BANNERS[status]();
  }

  return FLASH_BANNERS[500]();
};

const FlashBanner = ({ flash, dispatchHideFlashBanner }) => {
  if (!flash) return null;
  const { type, status, message } = flash;
  const DATA = bannerData(type, status);
  return (
    <Container color={DATA.color}>
      <Headline>{DATA && DATA.title}</Headline>
      <Copy>{message || (DATA && DATA.message)}</Copy>
      <Button
        color={DATA.buttonColor || DATA.color}
        aria-label="Dismiss flash"
        title="Close"
        onClick={dispatchHideFlashBanner}
      >
        <CloseIcon />
      </Button>
    </Container>
  );
};

export default enhancer(FlashBanner);

const Container = styled.div`
  ${BORDER_RADIUS_F1};
  background-color: ${({ color }) => color};
  opacity: ${OPACITY_25};
  padding: ${SPACING_MEDIUM};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  text-align: center;
  width: 100%;
  z-index: 9;
`;

const Headline = styled.h3`
  ${TYPE_SCALE_F5};
  ${FONT_WEIGHT_700};
  ${LINE_HEIGHT_TITLE};
  color: ${CLARK_SECONDARY};
  margin: 0;
`;

const Copy = styled.p`
  ${TYPE_SCALE_F6};
  ${FONT_WEIGHT_100};
  ${LINE_HEIGHT_COPY};
  color: ${CLARK_SECONDARY};
  margin: ${SPACING_SMALL} 0 0;
`;

const Button = styled.button`
  color: ${({ color }) => color};
  background: ${TRANSPARENT};
  border: 0;
  cursor: pointer;
  margin: ${SPACING_MEDIUM};
  outline: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: ${SPACING_LARGE};
`;



// WEBPACK FOOTER //
// ./src/containers/flash-banner/index.js